const doc = [({"en":({"js":({"tenants":({"setup":({"setup":"Setup"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;